import { render } from "./ToolColors.vue?vue&type=template&id=164b9e71"
import script from "./ToolColors.vue?vue&type=script&lang=js"
export * from "./ToolColors.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ToolColors.vue?vue&type=style&index=0&id=164b9e71&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__